import { getMessageInstance } from './utils/useMessage';

export const getList = async (params) => {
  if (!getMessageInstance) return;
  // eslint-disable-next-line no-return-await
  return await getMessageInstance().getMsgList(params);
};

export const getMsgTypeList = async (params) => {
  if (!getMessageInstance) return;
  // eslint-disable-next-line no-return-await
  return await getMessageInstance().getMsgTypeList(params);
};

export const putMsgRead = async (params) => {
  if (!getMessageInstance) return;
  // eslint-disable-next-line no-return-await
  return await getMessageInstance().putMsgRead(params);
};
